import { render, staticRenderFns } from "./PreviewDialog.vue?vue&type=template&id=ffb900b6&scoped=true"
import script from "./PreviewDialog.vue?vue&type=script&lang=js"
export * from "./PreviewDialog.vue?vue&type=script&lang=js"
import style0 from "./PreviewDialog.vue?vue&type=style&index=0&id=ffb900b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb900b6",
  null
  
)

export default component.exports